export enum WebCode {
    OK = 200,
    BlackList1 = 1002501,
    BlackList2 = 1002502,
    BlackList3 = 1002503,
    LostToken = 1001401,
    ErrorData = -1344,
    ServerError = 1001500,
    ForceLogOut = 1002203,
    AccountPwdError = 1022202,
    AccountExist = 1022207,
    VerifyCodeError = 1022811,
    VerifyCodeExpired = 1022806,
}

